import MapIcon from './Map.Icon';
import EngineersIcon from './Engineers.Icon';
import EqualizerIcon from './Equalizer.Icon';
import SpeakerIcon from './Speaker.Icon';
export const MAP_ICON = 'map';
export const ENGINEERS_ICON = 'engineers';
export const SPEAKER_ICON = 'speaker';
export const EQUALIZER_ICON = 'equalizer';

export const HEADER_ONE_ICONS = [
  MAP_ICON,
  ENGINEERS_ICON,
  EQUALIZER_ICON,
  SPEAKER_ICON
];

export function headerOneIconFactory(type) {
  switch (type) {
    case MAP_ICON:
      return MapIcon;
    case ENGINEERS_ICON:
      return EngineersIcon;
    case EQUALIZER_ICON:
      return EqualizerIcon;
    case SPEAKER_ICON:
      return SpeakerIcon;
  }
}



// WEBPACK FOOTER //
// ./src/components/ClubCMS/Content/HeaderOne/icons/index.js